import 'whatwg-fetch'; // need this for IE11


export default function newsloader() {
  const loadmore = document.querySelector('.news-load-more');

  if (loadmore) {
    const initialPage = loadmore.getAttribute('data-current-page');
    let currentPage = initialPage;
    const totalPages = loadmore.getAttribute('data-total-pages');

    loadmore.addEventListener('click', function(event) {
      const nextPage = parseInt(currentPage, 10) + 1;

      const currentHref = window.location.href;
      const pieces = currentHref.split('?');
      const url = pieces[0];

      let newUrl = url + '?page=' + nextPage;

      if (typeof pieces[1] !== 'undefined') {
        const urlParams = pieces[1].split('&');

        const filteredParams = urlParams.filter( (item) => {
          const strToCheck = item.substring(0, 4);
          return strToCheck !== 'page';
        });

        newUrl = url + '?' +
        filteredParams.join('&') +
        '&page=' + nextPage;
      }

      fetch(newUrl)
          .then((response) => response.text())
          .then(function(html) {
          // check whether this is the last page

            if (nextPage === parseInt(totalPages, 10)) {
              loadmore.remove();
            }

            // Initialize the DOM parser
            const parser = new DOMParser();

            // Parse the text
            const doc = parser.parseFromString(html, 'text/html');

            // You can now even select part of that html as you would
            // in the regular DOM
            // Example:
            const items = doc.querySelector('.news-articles').innerHTML;

            const articles = document.querySelector('.news-articles');
            articles.insertAdjacentHTML('beforeend', items);

            currentPage = nextPage;
          })
          .catch(function(err) {
            console.log('Failed to fetch page: ', err);
          });
    });
  }

  // const tagFilter = document.querySelector('#searchTags');

  // if (tagFilter) {
  //   tagFilter.addEventListener('change', (event) => {
  //     event.preventDefault();

  //     const currentUrl = window.location.href;
  //     let newUrl = '';
  //     const pieces = currentUrl.split('?');
  //     newUrl = pieces[0] + '?tag=' + tagFilter.value;
  //     window.location.href = newUrl;
  //   });
  // }

  const categoryFilter = document.querySelector('#searchCategory');

  if (categoryFilter) {
    categoryFilter.addEventListener('change', (event) => {
      event.preventDefault();

      const currentUrl = window.location.href;
      let newUrl = '';
      const pieces = currentUrl.split('?');
      newUrl = pieces[0] + '?category=' + categoryFilter.value;
      window.location.href = newUrl;
    });
  }
}
